import React from 'react';

import { useTheme } from '@mui/material';
import { ToastContainer } from 'react-toastify';

function OhsToastContainer() {
  const theme = useTheme();
  const style = {
    '--toastify-color-warning': theme.palette.warning.main,
    zIndex: theme.zIndex.modal + 2,
  } as React.CSSProperties;
  return (
    <ToastContainer
      position="bottom-right"
      autoClose={5000}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      style={style}
    />
  );
}

export default OhsToastContainer;
